import { useEffect, useState } from 'react';
import Tabs from '~/components/Tabs';
import { User } from './types/User';
import CampaignTable from './tables/CampaignTable';
import CampaignRequestTable from './tables/CampaignRequestTable';
import {
    fetchCampaignRequestsOfUser,
    fetchCampaignsOfUser,
} from '~/services/users';

interface Props {
    user: User;
}

const AdminTabs: React.FC<Props> = ({ user }) => {
    const [openTab, setOpenTab] = useState(1);
    const [campaigns, setCampaigns] = useState([]);
    const [campaignRequests, setCampaignRequests] = useState([]);
    const [campaignPage, setCampaignPage] = useState(1)
    const [campaignRequestPage, setCampaignRequestPage] = useState(1)
    const [campaignPages, setCampaignPages] = useState(0)
    const [campaignRequestPages, setCampaignRequestPages] = useState(0)
    const [campaignTotalCount, setCampaignTotalCount] = useState<number | undefined>(undefined)

    const tabs = [
        { name: 'Campaigns', count: campaigns.length },
        { name: 'Campaign Requests', count: campaignRequests.length },
    ];

    const fetchAndSetCampaignRequest = async () => {
        const campaignRequestResponse = await fetchCampaignRequestsOfUser({
            user_id: user?.id,
        });
        setCampaignRequests(campaignRequestResponse.results);
        const total = campaignRequestResponse?.count
        if (total)
            setCampaignRequestPages(Math.ceil(total / 10))
    };

    const fetchAndSetCampaign = async () => {
        const campaignResponse = await fetchCampaignsOfUser({
            user_id: user?.id,
        });
        setCampaigns(campaignResponse.results);
        const total = campaignResponse?.count
        if (total) {
            setCampaignTotalCount(total);
            setCampaignPages(Math.ceil(total / 10))
        }
    };
    useEffect(() => {
        fetchAndSetCampaign();
        fetchAndSetCampaignRequest();
    }, []);

    return (
        <>
            <Tabs tabNames={tabs} openTab={openTab} setOpenTab={setOpenTab}>
                {openTab == 1 && <CampaignTable campaigns={campaigns} page={campaignPage} setPage={setCampaignPage} pages={campaignPages} totalCount={campaignTotalCount} />}
                {openTab == 2 && <CampaignRequestTable campaigns={campaignRequests} />}
            </Tabs>
        </>
    );
};

export default AdminTabs;
